export default {
  // Authentication

  RequestManagerPasswordReset: {
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },
  ResetManagerPassword: {
    ResetCodeInvalid:
      "Das Passwort konnte nicht zurückgesetzt werden. Beginnen Sie den Vorgang bitte erneut.",
    InvalidPassword:
      "Ein Passwort muss aus mindestens 10 Zeichen bestehen und eine Zahl, " +
      "einen Groß- und Kleinbuchstaben, sowie ein Sonderzeichen beinhalten.",
  },

  UnpairDevice: {
    CashRegisterNotFound:
      "Die Verknüpfung mit der Kasse kann nicht aufgehoben werden, da diese nicht mehr existiert.",
    DeviceNotPaired: 'Die Kasse "%s" ist derzeit mit keinem Gerät verknüpft.',
  },

  // Cash register management

  ChangeCashRegisterConfiguration: {
    CashRegisterNotFound:
      "Sie können diese Kasse nicht bearbeiten, da diese nicht mehr existiert.",
    CashRegisterDisabled:
      "Sie können diese Kasse nicht bearbeiten, da diese derzeit deaktiviert ist.",
  },

  ChangeCashRegisterDrawerMode: {
    OperatorNotFound:
      "Der Tagesanfangsstand konnte nicht bearbeitet werden, da dieser Bediener nicht mehr existiert.",
    CashRegisterNotFound:
      "Der Tagesanfangsstand konnte nicht bearbeitet werden, da diese Kasse nicht existiert.",
    AmountNegative:
      "Der Tagesanfangsstand konnte nicht bearbeitet werden, da negative Bestände nicht erlaubt sind.",
    CashRegisterDisabled:
      "Sie können den Tagesanfangsstand nicht bearbeiten, da diese Kasse derzeit deaktiviert ist.",
  },

  ChangeA4ReceiptDesign: {
    CashRegisterNotFound:
      "Sie können das A4-Belegdesign nicht bearbeiten, da die dazugehörige Kasse nicht mehr existiert.",
    CashRegisterDisabled:
      "Sie können das A4-Belegdesign nicht bearbeiten, da diese Kasse derzeit deaktiviert ist.",
  },
  ChangePhysicalReceiptDesign: {
    CashRegisterNotFound:
      "Sie können das Bon-Belegdesign nicht bearbeiten, da die dazugehörige Kasse nicht mehr existiert.",
    CashRegisterDisabled:
      "Sie können das Bon-Belegdesign nicht bearbeiten, da diese Kasse derzeit deaktiviert ist.",
  },

  CreateKeyboardLayout: {
    KeyboardNameAlreadyExists:
      "Die eingegebene Bezeichnung für das Tastaturlayout ist bereits vergeben.",
    InvalidPortraitColumnCount:
      "Das Hochformat-Design eines Tastaturlayouts kann höchstens 3 Spalten besitzen.",
    InvalidLandscapeColumnCount:
      "Das Querformat-Design eines Tastaturlayouts kann höchstens 6 Spalten besitzen.",
    InvalidLayoutContent:
      "Es befinden sich Elemente (Tastenhauptgruppen, Tastenuntergruppen oder Artikeltasten) " +
      "im Tastaturlayout, welche nicht mehr existieren oder ungültig sind.",
  },
  ChangeKeyboardLayout: {
    KeyboardLayoutNotFound:
      "Das Tastaturlayout konnte nicht bearbeitet werden, da dieses nicht mehr existiert.",
    KeyboardNameAlreadyExists:
      "Die eingegebene Bezeichnung für das Tastaturlayout ist bereits vergeben.",
    InvalidPortraitColumnCount:
      "Das Hochformat-Design eines Tastaturlayouts kann höchstens 3 Spalten besitzen.",
    InvalidLandscapeColumnCount:
      "Das Querformat-Design eines Tastaturlayouts kann höchstens 6 Spalten besitzen.",
    InvalidLayoutContent:
      "Es befinden sich Elemente (Tastenhauptgruppen, Tastenuntergruppen oder Artikeltasten) " +
      "im Tastaturlayout, welche nicht mehr existieren oder ungültig sind.",
  },
  DeleteKeyboardLayout: {
    KeyboardLayoutNotFound: 'Das Tastaturlayout "%s" wurde bereits gelöscht.',
  },

  CreateKeysMainGroup: {
    KeysMainGroupNameExists:
      "Die eingegebene Bezeichnung für die Tastenhauptgruppe ist bereits vergeben.",
    InvalidColorCode:
      "Die ausgewählte Farbe entspricht keinem korrekten Farbcode.",
    InvalidGroupAssignment:
      "Einer Tastenhauptgruppe können nicht sowohl eine Hauptgruppe als auch Warengruppe hinzugefügt werden.",
    MainGroupNotFound: "Die referenzierte Hauptgruppe existiert nicht mehr.",
    ArticleGroupNotFound: "Die referenzierte Warengruppe existiert nicht mehr.",
  },
  ChangeKeysMainGroup: {
    KeysMainGroupNotFound:
      "Die Tastenhauptgruppe konnte nicht bearbeitet werden, da diese nicht mehr existiert.",
    KeysMainGroupNameExists:
      "Die eingegebene Bezeichnung für die Tastenhauptgruppe ist bereits vergeben.",
    InvalidColorCode:
      "Die ausgewählte Farbe entspricht keinem korrekten Farbcode.",
  },
  DeleteKeysMainGroup: {
    KeysMainGroupNotFound: 'Die Tastenhauptgruppe "%s" wurde bereits gelöscht.',
  },

  CreateKeysSubGroup: {
    KeysSubGroupNameExists:
      "Die eingegebene Bezeichnung für die Tastenuntergruppe ist unter dieser Tastenhauptgruppe bereits vergeben.",
    InvalidColorCode:
      "Die ausgewählte Farbe entspricht keinem korrekten Farbcode.",
    ArticleGroupNotFound: "Die referenzierte Warengruppe existiert nicht mehr.",
    KeysMainGroupNotFound:
      "Die referenzierte Tastenuntergruppe existiert nicht mehr.",
    ArticleKeyNotFound:
      "Mindestens eine der referenzierten Artikeltasten existiert nicht mehr.",
  },
  ChangeKeysSubGroup: {
    KeysSubGroupNotFound:
      "Die Tastenuntergruppe konnte nicht bearbeitet werden, da diese nicht mehr existiert.",
    KeysSubGroupNameExists:
      "Die eingegebene Bezeichnung für die Tastenuntergruppe ist unter dieser Tastenhauptgruppe bereits vergeben.",
    InvalidColorCode:
      "Die ausgewählte Farbe entspricht keinem korrekten Farbcode.",
    ArticleKeyNotFound:
      "Mindestens eine der referenzierten Artikeltasten existiert nicht mehr.",
  },
  DeleteKeysSubGroup: {
    KeysSubGroupNotFound: 'Die Tastenuntergruppe "%s" wurde bereits gelöscht.',
  },

  CreateArticleKey: {
    InvalidColorCode:
      "Die ausgewählte Farbe entspricht keinem korrekten Farbcode.",
    MainGroupNotFound: "Die referenzierte Hauptgruppe existiert nicht mehr.",
    ArticleGroupNotFound: "Die referenzierte Warengruppe existiert nicht mehr.",
    ArticleNotFound: "Der referenzierte Artikel existiert nicht mehr.",
    ArticleKeyAlreadyExists:
      "Es existiert bereits eine Artikeltaste zu diesem referenzierten Artikel.",
  },
  ChangeArticleKey: {
    ArticleKeyNotFound:
      "Die Artikeltaste konnte nicht bearbeitet werden, da diese nicht mehr existiert.",
    InvalidColorCode:
      "Die ausgewählte Farbe entspricht keinem korrekten Farbcode.",
    MainGroupNotFound: "Die referenzierte Hauptgruppe existiert nicht mehr.",
    ArticleGroupNotFound: "Die referenzierte Warengruppe existiert nicht mehr.",
    ArticleNotFound: "Der referenzierte Artikel existiert nicht mehr.",
    ArticleKeyAlreadyExists:
      "Es existiert bereits eine Artikeltaste zu diesem referenzierten Artikel.",
  },
  DeleteArticleKey: {
    ArticleKeyNotFound: 'Die Artikeltaste "%s" wurde bereits gelöscht.',
  },

  ChangeCloseOfDayTime: {
    // Currently no specific ErrorCode implemented
  },
  ChangeBillingReportApproach: {
    // Currently no specific ErrorCode implemented
  },

  // Master data management

  CreateMainGroup: {
    MainGroupNameExists:
      "Die eingegebene Bezeichnung für die Hauptgruppe ist bereits vergeben.",
    InvalidTaxRate: "Steuergruppen dürfen keinen negativen Wert annehmen.",
  },
  ChangeMainGroup: {
    MainGroupNotFound:
      "Die Hauptgruppe konnte nicht bearbeitet werden, da diese nicht mehr existiert.",
    MainGroupNameExists:
      "Die eingegebene Bezeichnung für die Hauptgruppe ist bereits vergeben.",
    InvalidTaxRate: "Steuergruppen dürfen keinen negativen Wert annehmen.",
  },
  ChangeMainGroupOrderIndex: {
    MainGroupNotFound:
      "Diese Hauptgruppe kann nicht verschoben werden, da sie nicht mehr existiert.",
    InvalidOrderIndex:
      "Diese Hauptgruppe kann nicht an die gewünschte Position verschoben werden.",
  },
  DeleteMainGroup: {
    MainGroupNotFound: 'Die Hauptgruppe "%s" wurde bereits gelöscht.',
    MainGroupNotEmpty:
      "Hauptgruppen können erst gelöscht werden, wenn sie keine Warengruppen enthalten.\n" +
      "Bitte löschen Sie zuerst alle zugeordneten Warengruppen und deren inkludierte Artikel.",
  },

  CreateArticleGroup: {
    MainGroupNotFound: "Die referenzierte Hauptgruppe existiert nicht mehr.",
    ArticleGroupNameExists:
      "Die eingegebene Bezeichnung für die Warengruppe ist unter dieser Hauptgruppe bereits vergeben.",
    InvalidTaxRate: "Steuergruppen dürfen keinen negativen Wert annehmen.",
  },
  ChangeArticleGroup: {
    ArticleGroupNotFound:
      "Die Warengruppe konnte nicht aktualisiert werden, da diese nicht mehr existiert.",
    ArticleGroupNameExists:
      "Die eingegebene Bezeichnung für die Warengruppe ist unter dieser Hauptgruppe bereits vergeben.",
    InvalidTaxRate: "Steuergruppen dürfen keinen negativen Wert annehmen.",
  },
  ChangeArticleGroupOrderIndex: {
    ArticleGroupNotFound:
      "Diese Warengruppe kann nicht verschoben werden, da sie nicht mehr existiert.",
    InvalidOrderIndex:
      "Diese Warengruppe kann nicht an die gewünschte Position verschoben werden.",
  },
  DeleteArticleGroup: {
    ArticleGroupNotFound: 'Die Warengruppe "%s" wurde bereits gelöscht.',
    ArticleGroupNotEmpty:
      "Warengruppen können erst gelöscht werden, wenn sie keine Artikel enthalten.\n" +
      "Bitte löschen Sie zuerst alle zugehörigen Artikel oder verschieben Sie sie in andere Warengruppen.",
  },

  CreateArticle: {
    MainGroupNotFound: "Die referenzierte Hauptgruppe existiert nicht mehr.",
    ArticleGroupNotFound: "Die referenzierte Warengruppe existiert nicht mehr.",
    ArticleNameExists:
      "Die eingegebene Bezeichnung für den Artikel ist bereits vergeben.",
    ArticleNumberExists:
      'Die Artikelnummer "%s" wurde bereits dem Artikel "%s" zugeordnet.',
    ArticleGroupNotGroupOfMainGroup:
      "Die referenzierte Warengruppe ist nicht Teil der referenzierten Hauptgruppe.",
    InvalidPrice: "Bitte geben Sie einen gültigen Artikelpreis ein.",
    InvalidTaxRate: "Steuergruppen dürfen keinen negativen Wert annehmen.",
    InvalidArticleNumber:
      "Die eingegebene Artikelnummer darf ausschließlich einer Ganzzahl entsprechen.",
    InvalidBarcodeNumber:
      "Mindestens einer der zugeordneten Barcodes ist ungültig.",
    BarcodeNumberAlreadyExists:
      'Der Barcode "%s" wurde bereits dem Artikel "%s" zugeordnet.',
    ArticleAndBarcodeNumberCollision:
      "Die eingegebene Artikelnummer darf nicht in den zugeordneten Barcodes enthalten sein.",
    ArticleNumberBarcodeNumberCollision:
      'Der Barcode "%s" wurde bereits als Artikelnummer dem Artikel "%s" zugeordnet.',
    BarcodeNumberArticleNumberCollision:
      'Die Artikelnummer "%s" wurde bereits als Barcode dem Artikel "%s" zugeordnet.',
  },
  ChangeArticle: {
    MainGroupNotFound: "Die referenzierte Hauptgruppe existiert nicht mehr.",
    ArticleGroupNotFound: "Die referenzierte Warengruppe existiert nicht mehr.",
    ArticleNotFound:
      "Der Artikel konnte nicht bearbeitet werden, da dieser nicht mehr existiert.",
    ArticleNameExists:
      "Die eingegebene Bezeichnung für den Artikel ist bereits vergeben.",
    ArticleNumberExists:
      'Die Artikelnummer "%s" wurde bereits dem Artikel "%s" zugeordnet.',
    ArticleGroupNotGroupOfMainGroup:
      "Die referenzierte Warengruppe ist nicht Teil der referenzierten Hauptgruppe.",
    InvalidPrice: "Bitte geben Sie einen gültigen Artikelpreis ein.",
    InvalidTaxRate: "Steuergruppen dürfen keinen negativen Wert annehmen.",
    InvalidArticleNumber:
      "Die eingegebene Artikelnummer darf ausschließlich einer Ganzzahl entsprechen.",
    InvalidBarcodeNumber:
      "Mindestens einer der zugeordneten Barcodes ist ungültig.",
    BarcodeNumberAlreadyExists:
      'Der Barcode "%s" wurde bereits dem Artikel "%s" zugeordnet.',
    ArticleAndBarcodeNumberCollision:
      "Die eingegebene Artikelnummer darf nicht in den zugeordneten Barcodes enthalten sein.",
    ArticleNumberBarcodeNumberCollision:
      'Der Barcode "%s" wurde bereits als Artikelnummer dem Artikel "%s" zugeordnet.',
    BarcodeNumberArticleNumberCollision:
      'Die Artikelnummer "%s" wurde bereits als Barcode dem Artikel "%s" zugeordnet.',
  },
  RemoveArticleNumber: {
    ArticleNotFound:
      "Der Artikel konnte nicht bearbeitet werden, da dieser nicht mehr existiert.",
  },
  RemoveArticleBarcodeNumbers: {
    ArticleNotFound:
      "Der Artikel konnte nicht bearbeitet werden, da dieser nicht mehr existiert.",
    InvalidBarcodeNumber:
      "Mindestens einer der übergebenen Barcodes ist ungültig.",
  },
  DeleteArticle: {
    ArticleNotFound: 'Der Artikel "%s" wurde bereits gelöscht.',
  },

  CreateDiscount: {
    InvalidValues: "Überprüfen Sie bitte den Wertebereich des Rabatts.",
    DiscountNameExists:
      "Die eingegebene Bezeichnung für den Rabatt ist bereits vergeben.",
  },
  ChangeDiscount: {
    DiscountNotFound:
      "Der Rabatt konnte nicht bearbeitet werden, da dieser nicht mehr existiert.",
    InvalidValues: "Überprüfen Sie bitte den Wertebereich des Rabatts.",
    DiscountNameExists:
      "Die eingegebene Bezeichnung für den Rabatt ist bereits vergeben.",
  },
  DeleteDiscount: {
    DiscountNotFound: 'Der Rabatt "%s" wurde bereits gelöscht.',
  },

  ChangePaymentMethodVisibility: {
    // Currently no specific ErrorCode implemented
  },

  CreateManagerCashFlow: {
    IsCompanyCashFlow:
      "Sie können im Admin-Interface keine unternehmensspezifischen Geldbewegungen anlegen.",
  },
  ChangeManagerCashFlow: {
    CashFlowNotFound:
      "Die Geldbewegung konnte nicht bearbeitet werden, da diese nicht mehr existiert.",
    IsGlobal:
      "Sie können keine globalen Geldbewegungen zu unternehmensspezifischen Geldbewegungen konvertieren.",
    IsCompanyCashFlow:
      "Sie können im Admin-Interface keine unternehmensspezifischen Geldbewegungen bearbeiten.",
  },
  DeleteManagerCashFlow: {
    CashFlowNotFound: 'Die Geldbewegung "%s" wurde bereits gelöscht.',
    IsGlobal: "Sie können keine globalen Geldbewegungen löschen.",
  },
  ChangeCashFlowVisibility: {
    CashFlowNotFound:
      "Die Sichtbarkeit der Geldbewegung kann nicht verändert werden, da diese nicht mehr existiert.",
  },

  // Operator management

  CreateOperator: {
    OperatorCodeExists: "Dieser Bediener-Code ist bereits vergeben.",
    DiscountPercentageNegative:
      "Eine negative Prozentangabe von Rabatten ist nicht möglich.",
    InvalidPassword:
      "Das Passwort darf weder leer sein, noch aus Leerzeichen bestehen.",
    NoOperatorCodesLeft: "Es sind keine Bediener-Codes mehr frei.",
  },
  ChangeOperator: {
    AccountNotFound:
      "Der Bediener konnte nicht bearbeitet werden, da dieser nicht mehr existiert.",
    OperatorCodeExists: "Dieser Bediener-Code ist bereits vergeben.",
    DiscountPercentageNegative:
      "Eine negative Prozentangabe von Rabatten ist nicht möglich.",
  },
  ChangeOperatorDrawerMode: {
    OperatorNotFound:
      "Der Tagesanfangsstand konnte nicht bearbeitet werden, da dieser Bediener nicht mehr existiert.",
    CashRegisterNotFound:
      "Der Tagesanfangsstand konnte nicht bearbeitet werden, da diese Kasse nicht existiert.",
    AmountNegative:
      "Der Tagesanfangsstand konnte nicht bearbeitet werden, da negative Bestände nicht erlaubt sind.",
    CashRegisterDisabled:
      "Sie können den Tagesanfangsstand nicht bearbeiten, da diese Kasse derzeit deaktiviert ist.",
  },

  // Contacts

  SendContactsPerMail: {
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },

  // Receipts

  SendReceiptsPerMail: {
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },

  // Reports

  SendArticleReportByMail: {
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },
  SendGroupReportByMail: {
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },
  SendAccountingReportByMail: {
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },
  SendCashFlowReportByMail: {
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },
  SendCashRegisterLedgerReportPerMail: {
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },

  CloseEndOfDayReport: {
    DateNotActive:
      "Der Tagesabschluss für den ausgewählten Abrechnungstag wurde bereits durchgeführt.",
  },

  // RKSV

  SendRksvInfoByMail: {
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
    NoStartReceiptPresent:
      "Es wurde noch kein Startbeleg für dieses Unternehmen erstellt.",
  },

  SendRksvReceiptsPerMail: {
    InvalidEmailAddress: "Die eingegebene E-Mail-Adresse ist ungültig.",
  },
} as const
